import { lazy } from 'react';

const loadOpportunity = () => import('./Opportunities');
const PageOpportunity = lazy(loadOpportunity);

export default PageOpportunity;
